
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-16a401bb\",\"scoped\":true,\"hasInlineConfig\":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Profile.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Profile.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-16a401bb\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Profile.vue"),
  /* scopeId */
  "data-v-16a401bb",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/Profile.vue
// module id = 508
// module chunks = 1